import { useTranslation } from 'react-i18next';
import { applyChromeLocale } from './config';
import type { Locale } from '@/lib/api/types';

/** Current chrome locale + a setter that flips i18next and <html lang/dir>. */
export function useLocale(): { locale: Locale; isRtl: boolean; setLocale: (l: Locale) => void } {
  const { i18n } = useTranslation();
  const locale = (i18n.language === 'ar' ? 'ar' : 'en') as Locale;
  return {
    locale,
    isRtl: locale === 'ar',
    setLocale: (l: Locale) => applyChromeLocale(l),
  };
}
